<template>
    <layout-general-container spaceToolbar>
        <div class="w-full flex justify-center">
            <div class="w-full flex flex-col gap-10">
                <div
                    class="bg-banner-1 h-[40vh] border-b px-6 flex flex-col gap-8 items-center justify-center text-center w-full">
                    <h1 class="text-white text-4xl font-semibold tracking-wide">Our Course</h1>
                    <h2 class="text-white tracking-wide leading-loose md:max-w-6xl font-light">Explore our extensive catalog and find the perfect course to enhance your knowledge and skills.</h2>
                </div>
                <div class="w-full px-6 md:px-8 xl:px-14 flex-col flex gap-8 bg-white">
                    <!-- <div class="flex flex-row items-center gap-3">
                        <span class="text-sm font-medium min-w-max">Topic :</span>
                        <a-select class="w-full md:w-[12rem]" :value="categoryId ?? '-- Select --'" :options="categoryOptions" @change="onChangeTopic">
                            <template #suffixIcon>
                                <IconCategory2 :size="18" />
                            </template>
                        </a-select>
                    </div> -->
                    <div class="w-full gap-6 grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3" v-if="courses.length > 0">
                        <card-course v-for="item in courses" :key="item.category_id" :title="item.title" :duration="item.duration"
                            :enrolled="item.isEnrolled" :rating="Number(item.rating)" :image="item.photo" :enroll="item.total_reviews"
                            :id="item.id" :slug="item.slug" :featured="item.featured" :category="item.category" 
                            :speakerName="item.speaker_name"
                            :lesson="item?.total_lessons"
                            :completed="item?.total_completed"
                            :finished="item?.finished_percentage"
                            :speakerPhoto="item.speaker_photo" 
                            :isFree="item.program_id == null" />
                    </div>

                    <div class="w-full gap-6 flex justify-center" v-else>
                        <span class="text-sm text-gray-500 text-center">
                            No Course Found.
                        </span>
                    </div>
                    <a-pagination 
                        v-model:current="page" 
                        :total="total"
                        :page-size="20"
                        :show-total="total => `Total ${total} items`" 
                        :id="'course-pagination'"
                    />
                </div>
            </div>
        </div>
    </layout-general-container>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import DummyCategories from '../../assets/Dummy/category.js';
import axios from "@/plugins/axios";
import { IconSearch, IconSortDescending, IconCategory2, IconChartDonut } from "@tabler/icons-vue";

const tab = ref('All');
const tabs = ref(['All', 'Current', 'Completed', 'Not-Started']);
const total = ref(0);
const page = ref(1);
const courses = ref([]);
const categoryId = ref(null);
const sortOptions = ref([
    { title: 'Most Relevant', value: 'Most Relevant' },
    { title: 'Highest Rating', value: 'Highest Rating' },
    { title: 'Longest Duration', value: 'Longest Duration' },
    { title: 'Newest', value: 'Newest' },
]);
const categoryOptions = ref([]);

const fetchTopics = async () => {
    try {
        const response = await axios.get('/category');
        
        categoryOptions.value = (response?.data).map(t => ({ label: t.name, value: t.id }));
    } catch (error) {
        console.error('Error fetching topic:', error)
    }
}

const fetchCourses = async () => {
    try {
        const response = await axios.get('/course?page='+page.value, {
            params: {
                topic: categoryId.value,
            }
        })
        
        total.value = response?.data?.total_items

        courses.value = response?.data?.data
    } catch (error) {
        console.error('Error fetching courses:', error)
    }
}

const onChangeTopic = async (value) => {
    categoryId.value = value
    fetchCourses()
}
watch(page, () => {
    fetchCourses();
});

onMounted(() => {
    fetchTopics();
    fetchCourses();
});
</script>

